import { writable, readable} from 'svelte/store';
import { toast } from '@zerodevx/svelte-toast';
import { debounce } from 'lodash';
import { createNanoEvents } from 'nanoevents';
// import { BloomFilter } from 'bloom-filters';
// const { BloomFilter } = require('bloom-filters');
// import * as buffer from 'buffer';
// import * as BloomFilter from 'bloom-filters';
// import { BloomFilter } from 'bloom-filters/dist/bloom/bloom-filter.js';

// import * as BloomFilter from 'bloom-filters/dist/bloom/bloom-filter.js';

export const emitter = readable(createNanoEvents());


export function isEmptyOrSpaces(str){
    return str === null || str.match(/^ *$/) !== null;
}

export function cleanCurrency(amount){
    try{
        return parseFloat(amount.toString().replace(/[^\d.-]/g, '').trim()).toLocaleString('en-US', {style: 'currency', currency: 'USD'});
    }catch(e){
        return amount;
    }
}

let current_invalid_items = [];
export let dbClearAllInvalidItems = debounce(clearAllInvalidItems, 300);

export function clearAllInvalidItems(){
    for(let i = 0; i < current_invalid_items.length; i++) {
        current_invalid_items[i].classList.remove("invalid");
    }
    current_invalid_items = [];
}

export function invalidateItem(the_element, the_reason){
    if(the_element !== undefined && the_element.classList !== undefined){
        the_element.classList.add("invalid");
        current_invalid_items.push(the_element);
        userNotification("error", "Invalid Data", the_reason);
    }
}

export function parseCityStateZip(csv_string) {
    let res = {st: false, type: undefined};

    csv_string = csv_string.trim();
    // is it a zip code?
    if(/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(csv_string)){
        res.st = true;
        res.type = "zip";
        res.value = [csv_string];
    }

    // is it a city and state?
    if( /^[\S ]+[ ]*,[ ]*[A-Za-z ]{2,}$/.test(csv_string)){
        res.st = true;
        res.type = "cs";
        res.value = csv_string.split(",").map((e)=>{return e.trim()});
    }

    return res;

}

export function userNotification(notification_type, notification_title, notification_message){

    if(notification_type === "error") {
        toast.push(notification_message, {
            theme: {
              '--toastBackground': '#F56565',
              '--toastBarBackground': '#EF4642'
            }
          });    
    }

    console.log(`MESSAGE_TYPE: ${notification_type}`);
    console.log(`MESSAGE_TITLE: ${notification_title}`);
    console.log(`MESSAGE_MESSAGE: ${notification_message}`);
}

export const user_data_test = writable(
    {
        "propertyaddress":"",
        "propertyaptunit":"",
        "propertycity":"Eden",
        "propertystate":"NC",
        "propertyzipcode":"27288",
        "propertycounty":"Rockingham",
        "loantype":"Refinance",
        "purchaseprice":"350000",
        "downpaymentamount":"0",
        "downpaymentpercentage":"0",
        "propertytype":"Single Family",
        "creditscore":"659",
        "military":false,
        "firsttimebuyer":false,
        "propertyvalue":"350000",
        "currentbalance":"250000",
        "cashoutamount":"0",
        "debtconsolidationamount":"",
        "whereinprocess":"",
        "howcanwehelp":"",
        "whenplanningtopurchase":"",
        "whenpayoffmortgage":"",
        "hometype":"PrimaryResidence",
        "workingwithrealtor":false,
        "refigoal":"",
        "firstname":"",
        "lastname":"",
        "mobilephone":"",
        "email":"",
        "bestcontactmethod":"Email",
        "bestcontacttime":"Morning",
        "currentaddress":"",
        "currentaptunit":"",
        "currentcity":"",
        "currentstate":"",
        "currentzipcode":"",
        "loanType": "Conventional", //or FHA or VA
        "selected_product":null,
        "down_payment_percent":"22"
     }
);

export const user_data = writable({
    "does_qualify": true,
    "skip_home_type": false,
    "current_home_owner": false,
    "propertyaddress": "",
    "propertyaptunit": "",
    "propertycity": "",
    "propertystate": "",
    "propertyzipcode": "",
    "propertycounty": "",
    "loantype": "Purchase", //purchase or finance
    "purchaseprice": "",
    "downpaymentamount": "",
    "downpaymentpercentage": "",
    "propertytype": "Single Family", //singlefamily, condo, multifamly
    "creditscore": "850",
    "military": false,
    "firsttimebuyer": false,
    "propertyvalue": "",
    "currentbalance": "",
    "cashoutamount": "",
    "debtconsolidationamount": "",
    "whereinprocess": "", //research, open house, making offers, purchase contract
    "howcanwehelp": "",
    "whenplanningtopurchase": "",
    "whenpayoffmortgage": "",    
    "hometype": "PrimaryResidence", //primary residence, second home, investment
    "workingwithrealtor": false,
    "refigoal": "", //lower payment, cashout, payoff, etc.
    "firstname": "",
    "lastname": "",
    "mobilephone": "",
    "email": "",
    "bestcontactmethod": "",
    "bestcontacttime": "",
    "currentaddress": "",
    "currentaptunit": "",
    "currentcity": "",
    "currentstate": "",
    "currentzipcode": "",
    "loanType": "Conventional", //or FHA or VA
    "selected_product": null,
});


export const flow_stack = writable({});

// export const flow_info = writable({
//     // current_flow: "no_flow",
//     // current_step: 1,
//     iq: [
//         {s:2, r:"/iq?i=0&s=2&n=8", nflow:{"Purchase": "iqp", "Refinance": "iqr"}}
//     ],
//     iqp: [
//         "/iqp_price_downpayment?i=0&s=3&n=8",
//         // "/iqp_price_downpayment?i=1&s=4&n=8",
//         "/iqp_property_type?i=2&s=5&n=8",
//         "/iqp_credit_score_estimate?i=3&s=6&n=8",
//         "/iqp_military_veteran?i=4&s=7&n=8",
//     ],
//     iqr: [
//         {s:3, r:"/iqr_property_type"},
//         {s:4, r:"/iqr_current_loan"},
//         {s:5, r:"/iqr_credit_score"},
//         {s:6, r:"/iqr_military_veteran", npage: "/rates"},
//     ],
//     detailed_flow: []
// });

export const flow_steps = writable({
    current_next_loc: 0,
    current_prev_loc: 0,
    current_percentage: 0,
    current_flow: "he",
    flows:{
        he: [
            "/",
            "/loan_amount",
            "/credit_score",
            "/first_time_home_owner",
            "/current_home_type",
            "/qualify",
            "/thank_you",

        ],
        iqp: [
            "/",
            "/iq",
            "/iqp_price_downpayment?p=14&f=iqp&b=1&n=3",
            "/iqp_property_type?p=28&f=iqp&b=2&n=4",
            "/iqp_credit_score_estimate?p=3C&f=iqp&b=3&n=5",
            "/iqp_military_veteran?p=50&f=iqp&b=4&n=6",
            "/rate_table?f=iqp",
            "/dfp_about_yourself",
            "/dfp_thank_you",
        ],
        iqr: [
            "/",
            "/iq",
            "/iqp_property_type?p=14&f=iqr&b=1&n=3",
            "/iqr_current_loan?p=28&f=iqr&b=2&n=4",
            "/iqp_credit_score_estimate?p=3C&f=iqr&b=3&n=5",
            "/iqp_military_veteran?p=50&f=iqr&b=4&n=6",
            "/rate_table?f=iqr",
            "/dfp_about_yourself",
            "/dfp_thank_you",
        ],    
        drp: [
            "/",
            "/df",
            "/dfp_process_status?p=8&f=drp&b=1&n=3",
            "/dfp_how_can_we_help?p=10&f=drp&b=2&n=4",
            "/dfp_when_planning_purchase?p=18&f=drp&b=3&n=5",
            "/dfp_home_type?p=20&f=drp&b=4&n=6",
            "/dfp_property_type?p=28&f=drp&b=5&n=7",
            "/dfp_property_location?p=30&f=drp&b=6&n=8",
            "/dfp_credit_score_estimate?p=38&f=drp&b=7&n=9",
            "/dfp_price_downpayment?p=40&f=drp&b=8&n=10",
            "/dfp_military_veteran?p=48&f=drp&b=9&n=11",
            "/dfp_current_realtor?p=50&f=drp&b=10&n=12",
            "/dfp_about_yourself?p=58&f=drp&b=11&n=13",
            "/dfp_thank_you",
        ],    
        dbp: [
            "/",
            "/df",
            "/dfp_process_status?p=8&f=dbp&b=1&n=3",
            "/dfp_how_can_we_help?p=10&f=dbp&b=2&n=4",
            "/dfp_when_planning_purchase?p=18&f=dbp&b=3&n=5",
            "/dfp_home_type?p=20&f=dbp&b=4&n=6",
            "/dfp_property_type?p=28&f=dbp&b=5&n=7",
            "/dfp_property_location?p=30&f=dbp&b=6&n=8",
            "/dfp_credit_score_estimate?p=38&f=dbp&b=7&n=9",
            "/dfp_price_downpayment?p=40&f=dbp&b=8&n=10",
            "/dfp_military_veteran?p=48&f=dbp&b=9&n=11",
            "/dfp_current_realtor?p=50&f=dbp&b=10&n=12",
            "/dfp_about_yourself?p=58&f=dbp&b=11&n=13",
            "/dfp_thank_you",
        ],    
        dgp: [
            "/",
            "/df",
            "/dfp_process_status?p=8&f=dgp&b=1&n=3",
            "/dfr_new_property_address?p=10&f=dgp&b=2&n=4",
            "/dfr_home_type_purchasing?p=18&f=dgp&b=3&n=5",
            "/dfp_property_type?p=20&f=dgp&b=4&n=6",
            "/dfp_property_location?p=28&f=dgp&b=5&n=7",
            "/dfp_credit_score_estimate?p=30&f=dgp&b=6&n=8",
            "/dfp_price_downpayment?p=38&f=dgp&b=7&n=9",
            "/dfp_military_veteran?p=40&f=dgp&b=8&n=10",
            "/dfp_current_realtor?p=48&f=dgp&b=9&n=11",
            "/dfp_about_yourself?p=50&f=dgp&b=10&n=12",
            "/dfp_thank_you",
        ],    
        drr: [
            "/",
            "/df",
            "/dfr_financing_goal?p=8&f=drr&b=1&n=3",
            "/dfr_property_address?p=10&f=drr&b=2&n=4",
            "/dfr_property_type?p=18&f=drr&b=3&n=5",
            "/dfr_home_type?p=20&f=drr&b=4&n=6",
            "/dfr_home_value_estimate?p=28&f=drr&b=5&n=7",
            "/dfr_cashout_amount?p=30&f=drr&b=6&n=8",
            "/dfp_military_veteran?p=38&f=drr&b=7&n=9",
            "/dfp_credit_score_estimate?p=40&f=drr&b=8&n=10",
            "/dfp_about_yourself?p=48&f=drr&b=9&n=11",
            "/dfp_thank_you",
        ],    
        dgr: [
            "/",
            "/df",
            "/dfr_financing_goal?p=8&f=dgr&b=1&n=3",
            "/dfr_property_address?p=10&f=dgr&b=2&n=4",
            "/dfr_property_type?p=18&f=dgr&b=3&n=5",
            "/dfr_home_type?p=20&f=dgr&b=4&n=6",
            "/dfr_home_value_estimate?p=28&f=dgr&b=5&n=7",
            "/dfr_consolidation_amount?p=30&f=dgr&b=6&n=8",
            "/dfp_military_veteran?p=38&f=dgr&b=7&n=9",
            "/dfp_credit_score_estimate?p=40&f=dgr&b=8&n=10",
            "/dfp_about_yourself?p=48&f=dgr&b=9&n=11",
            "/dfp_thank_you",
        ],    
        dbr: [
            "/",
            "/df",
            "/dfr_financing_goal?p=8&f=dbr&b=1&n=3",
            "/dfr_property_address?p=10&f=dbr&b=2&n=4",
            "/dfr_property_type?p=18&f=dbr&b=3&n=5",
            "/dfr_home_type?p=20&f=dbr&b=4&n=6",
            "/dfr_home_value_estimate?p=28&f=dbr&b=5&n=7",
            "/dfr_pay_off_mortgage?p=30&f=dbr&b=6&n=8",
            "/dfp_military_veteran?p=38&f=dbr&b=7&n=9",
            "/dfp_credit_score_estimate?p=40&f=dbr&b=8&n=10",
            "/dfp_about_yourself?p=48&f=dbr&b=9&n=11",
            "/dfp_thank_you",
        ],    
    },

});


export async function searchCSZ(the_zip){
    
    return new Promise(async (resolve, reject) => {
        await superagent
        .post('/api/obapi')
        .send({ action: 'search_zipcode', search_data: the_zip }) // sends a JSON post body
        .set('accept', 'json')
        .end((err, res) => {
// console.log(err);
// console.log(res);
            if(err !== null){
                    reject(undefined);
            }else{
                const jres = JSON.parse(res.text);
// console.log(jres);
                if(jres.st){
                    resolve(jres.data);
                }else{
                    reject(undefined);
                }
            }
        });
    });
    // let promise = new Promise(function(resolve, reject) {
// the function is executed automatically when the promise is constructed

// after 1 second signal that the job is done with the result "done"
//   setTimeout(() => resolve("done"), 1000);
// });

    // return tres;
}

export function countyChecker(){
    // console.log("I am starting a check here");
    let tud;
    const unsubscribe = user_data.subscribe(value => {
        tud = value;
        // console.log(value);
    }); // logs 'got a subscriber', then '1'
    
    searchCSZ(tud.propertyzipcode).then(e => {
        console.log(e);
        if(e.length > 0){
            tud['propertycounty'] = e[0]["county"];
            tud['propertycity'] = e[0]["city"];
            tud['propertystate'] = e[0]["state"];
            tud['propertyzipcode'] = e[0]["zip_code"];
            user_data.set(tud);    
        }
        unsubscribe();
    });

}

export async function updatePropertyZipInfo(new_zip){
    // console.log("I am starting a check here");
    let tud;
    const unsubscribe = user_data.subscribe(value => {
        tud = value;
        // console.log(value);
    }); // logs 'got a subscriber', then '1'
   
    
    await searchCSZ(new_zip).then(e => {
        console.log(e);
        if(e.length > 0){
            tud['propertycounty'] = e[0]["county"];
            tud['propertycity'] = e[0]["city"];
            tud['propertystate'] = e[0]["state"];
            tud['propertyzipcode'] = e[0]["zip_code"];
            user_data.set(tud);    
        }
        unsubscribe();
    });

}

let zip_filter;
// async function loadZipFilter(){
//     fetch("/json/zip_filter.json").then(async (res) => {
//         console.log("... back with zipfilter json");
//         // let jdata = await res.json();
//         res.json().then(jdata => {
//             console.log(jdata);
//             zip_filter = BloomFilter.default.fromJSON(jdata);
//             console.log(zip_filter);
//             console.log("... loaded zipfilter");    
//         });
//       });
  
// }

// loadZipFilter();

export function checkZip(zip){
    return zip_filter.has(zip)
}
